import sortCinemas from '../../../functions/sortCinemas'
import Translation from '../../Translation/cont/Translation'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import FormAdvertisements from '../../forms/FormAdvertisements'

const EditAdvertisements = ({itemData, onUpdateItem, cliCinemas, closePagePath, features, sliderAppearance, bannerAppearance, clientCinemaId}) => {
    if(!clientCinemaId) {
        return ''
    }

    const pageName = itemData && itemData.title ? itemData.title : <Translation id="advertisement_default_title"/>
    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page site-content">
                {itemData ? (
                    <FormAdvertisements
                        itemData={itemData} 
                        features={features} 
                        sliderAppearance={sliderAppearance}
                        bannerAppearance={bannerAppearance}
                        cliCinemas={cliCinemas} 
                        clientCinemaId={clientCinemaId} 
                        cliCinemasIdList={cliCinemasIdList}
                        closePagePath={closePagePath}
                        onUpdateItem={onUpdateItem}
                    />
                ):(
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default EditAdvertisements